import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../../../utils/axios';
const initialState = {
    data: [],
    loading: false,
    message: "",
    completed: false,
    hasError: false,
};

export const fetchListoptionData = createAsyncThunk(
    'listOptionsData/fetchListoptionData',
    async () => {
        const response = await axiosInstance.request({
            url: `/settings/nbcuweighting/list`,
            method: `GET`,
        });
        return response;
    }
);


const listOptionsDataSlice = createSlice({
    name: 'listOptionsData',
    initialState,
    reducers: {
        clearData: () => {
            return initialState;
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchListoptionData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchListoptionData.fulfilled, (state, action) => {
                state.loading = false;
                state.completed = true;
                state.data = action.payload.data;
            })
            .addCase(fetchListoptionData.rejected, (state, action) => {
                state.loading = false;
                state.completed = true;
                state.hasError = true;
                state.message = action.error.message;
            });

    },
});

const ListOptionsDataReducer = listOptionsDataSlice.reducer;

export default ListOptionsDataReducer;

export const listOptionsDataAction = listOptionsDataSlice.actions;